import { renderCustomColumnDefs } from "../../../../shared/Table/table.utils";
import { formatDate, renderAmount } from "../../../../utils";

// Config for Manifest report table
const tableConfig = [
  {
    id: "manifestId",
    header: "Manifest ID",
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "date",
    header: "Date",
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "driver",
    header: "Driver",
    cell: ({ getValue }) => {
      const driver = getValue();
      if (!driver) return "-";
      if (typeof driver === "string") return driver;
      return (
        driver?.fullName ||
        `${driver?.firstName || ""} ${driver?.lastName || ""}`.trim() ||
        "-"
      );
    },
  },
  {
    id: "status",
    header: "Status",
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "totalMileage",
    header: "Total Mileage",
    cell: ({ getValue }) => {
      const value = getValue();
      if (value === null || value === undefined) return "-";
      return `${value.toLocaleString()} mi`;
    },
  },
  {
    id: "totalDrops",
    header: "Total Drops",
    cell: ({ getValue }) => {
      const value = getValue();
      if (value === null || value === undefined) return "-";
      return value.toString();
    },
  },
  {
    id: "total",
    header: "Gross",
    cell: ({ getValue }) => renderAmount(getValue()),
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
